/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// Rules are disabled because a div that has an onclick here is used only
// for events propagation and decorative purposes

import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import AraraIcon from '../../AraraIcon';
import useStyles from './styles';


const inputStateToColorDictionary = {
  normal: 'gray',
  error: 'red',
  focus: 'black',
  confirmed: 'green',
};

const passwordStateToVariantDictionary = {
  [true]: 'visible',
  [false]: 'invisible',
};

const getInputState = (value, error, focus, touched, onlyFocusHighlight) => {
  if (focus) return 'focus';
  if (!touched) return 'normal';
  if (!onlyFocusHighlight && error) return 'error';
  if (!onlyFocusHighlight && value) return 'confirmed';
  return 'normal';
};


const ComplexTextInput = ({
  id,
  title,
  type,
  value,
  iconName,
  disabled,
  onChange,
  onBlur,
  error,
  onClick,
  onlyFocusHighlight,
  altClasses,
  grayBackground,
  touched,
  options,
  setFieldValue,
  hasShowPasswordButton,
  titleTop,
}) => {
  const [isFocused, setFocus] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const isMobile = useMediaQuery('(max-width:900px)');

  const defaultClasses = useStyles();
  const classes = useMemo(() => {
    if (!altClasses) return defaultClasses;
    return { ...defaultClasses, ...altClasses };
  }, [altClasses, defaultClasses]);

  const inputRef = React.createRef();
  const focus = () => {
    inputRef.current.focus();
    setFocus(true);
  };
  const onFocusHandler = () => {
    setFocus(true);
  };
  const onBlurHandler = e => {
    setFocus(false);
    onBlur(e);
  };
  const onChangeHandler = e => {
    onChange(e);
    if (type === 'url') {
      const url = e.currentTarget.value;
      if (!url.match(/^https?:\/\//)) {
        setFieldValue(id, `https://${url}`);
      }
    }
  };
  const openPassword = () => {
    setShowPassword(!showPassword);
  };

  const inputType = type !== 'password' ? type : (showPassword ? 'text' : 'password');
  const inputState = getInputState(value, error, isFocused, touched, onlyFocusHighlight);
  const inputClass = classNames(
    classes.input,
    { [classes.grayBackground]: grayBackground },
    { [classes.textArea]: inputType === 'textarea' },
    { [classes.inputWithValue]: value },
    { [classes.inputError]: error },
    { [classes.inputCorrect]: inputState === 'confirmed' },
    { [classes.disabled]: disabled },
  );
  const containerClass = classNames(
    classes.container,
    { [classes.fixedHeight]: type !== 'textarea' },
  );

  return (
    <div className={containerClass}>
      {type === 'textarea' && (
        <textarea
          ref={inputRef}
          className={inputClass}
          id={id}
          type={inputType}
          value={value}
          disabled={disabled}
          onChange={onChangeHandler}
          onFocus={onFocusHandler}
          onBlur={onBlurHandler}
          options={options}
          title={title}
          onClick={onClick}
          onKeyPress={onClick}
        />
      )}
      {type !== 'textarea' && (
        <input
          ref={inputRef}
          className={inputClass}
          id={id}
          type={inputType}
          value={value}
          disabled={disabled}
          onChange={onChangeHandler}
          onFocus={onFocusHandler}
          onBlur={onBlurHandler}
          options={options}
          title={title}
          onClick={onClick}
          onKeyPress={onClick}
        />
      )}
      <span style={{ top: titleTop(value, isFocused, isMobile) }} className={classes.title} onClick={focus}>{title}</span>
      {iconName && (
        <AraraIcon
          className={classes.image}
          name={iconName}
          variant={inputStateToColorDictionary[inputState]}
          onClick={focus}
        />
      )}
      {type === 'password' && hasShowPasswordButton && (
        <AraraIcon
          className={classes.statusIcon}
          name="eye"
          variant={passwordStateToVariantDictionary[showPassword]}
          onClick={openPassword}
        />
      )}
      {(type !== 'password' && (inputState === 'error' || inputState === 'confirmed')) && (
        <AraraIcon
          className={classes.statusIcon}
          name={inputState === 'error' ? 'error-circle' : 'checkmark-circle'}
          noVariants
          onClick={focus}
        />
      )}
    </div>
  );
};

ComplexTextInput.defaultProps = {
  title: '',
  type: 'text',
  value: '',
  iconName: null,
  onBlur: () => {},
  disabled: false,
  onChange: () => {},
  error: false,
  onlyFocusHighlight: false,
  altClasses: null,
  grayBackground: true,
  touched: true,
  options: null,
  onClick: () => {},
  setFieldValue: () => {},
  titleTop: () => {},
  hasShowPasswordButton: true,
};

ComplexTextInput.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  iconName: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  error: PropTypes.bool,
  touched: PropTypes.bool,
  onlyFocusHighlight: PropTypes.bool,
  altClasses: PropTypes.objectOf(PropTypes.string),
  grayBackground: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.object),
  onClick: PropTypes.func,
  setFieldValue: PropTypes.func,
  titleTop: PropTypes.func,
};

export default ComplexTextInput;
